module.exports = __webpack_public_path__ + "static/img/serviceP2.983f3592.png";